<script setup lang="ts">
import { useI18n } from "vue-i18n";

import Button from "@/dsComponents/buttons/Button.vue";
import Modal from "@/dsComponents/modals/Modal.vue";

defineProps<{
    open: boolean;
}>();

const emit = defineEmits<{
    (e: "close"): void;
    (e: "submit"): void;
}>();

const { t } = useI18n();
</script>

<template>
    <Modal :open="open" @close="emit('close')">
        <div class="dialog-content">
            <div class="dialog-c-title">{{ t("modals.companyEmailMissing.title") }}</div>
            <div class="dialog-c-text">
                <p>{{ t("modals.companyEmailMissing.description") }}</p>
                <div class="actions">
                    <Button size="sm" type="neutral" icon="cross" @click="emit('close')">{{ t("global.actions.close") }}</Button>
                    <Button size="sm" type="primary" icon="pen" @click="emit('submit')">{{ t("modals.companyEmailMissing.actions.edit") }}</Button>
                </div>
            </div>
        </div>
    </Modal>
</template>

<style lang="scss">
.CompanyEmailMissing {
    cursor: default;
    .actions {
        display: flex;
        justify-content: center;
    }
}
</style>
